import React from "react";
import { MessageRenderer } from "../../../../../components/MessageWithTableRenderer";
import { LoadingDots } from "./HistoryStates";
import { SummaryBlock } from "./SummaryBlock";
import { formatTime } from "../historyFormat";

// The open part of a row: the summary bar, the messages, and the way back into
// the chat. Rounds its own bottom corners: the card does not clip, so the
// folder menu can overhang it.
export function ConversationTranscript({ conv, language, detail, summarizing, onGenerateSummary, onContinue }) {
  return (
    <div className="rounded-b-xl border-t border-gray-100 dark:border-gray-700 bg-gray-50 dark:bg-gray-900/40 animate-fadeIn">
      <SummaryBlock conv={conv} language={language} busy={summarizing} onGenerate={onGenerateSummary} />
      {detail?.loading ? (
        <div className="py-8 flex justify-center">
          <LoadingDots language={language} small />
        </div>
      ) : detail?.error ? (
        <p className="text-sm text-red-600 dark:text-red-400 px-4 py-6 text-center">
          {language === "zh" ? "載入對話失敗。" : "Failed to load conversation."}
        </p>
      ) : (
        <div className="px-3 sm:px-4 py-4 space-y-3 max-h-[26rem] overflow-y-auto">
          {(detail?.messages || []).map((msg, index) => {
            const isUser = msg.role === "user";
            return (
              <div key={msg.id || index} className={`flex flex-col ${isUser ? "items-end" : "items-start"}`}>
                <div
                  className={`max-w-[85%] px-3.5 py-2.5 text-sm shadow-sm break-words ${
                    isUser
                      ? "bg-orange-500 text-white rounded-2xl rounded-br-sm"
                      : "bg-white dark:bg-gray-700 text-gray-800 dark:text-gray-100 border border-gray-200 dark:border-gray-600 rounded-2xl rounded-bl-sm"
                  }`}
                  style={{ wordBreak: "break-word", overflowWrap: "anywhere" }}
                >
                  <MessageRenderer text={msg.message} language={language} hideActionLinks />
                </div>
                <span className="text-[11px] text-gray-400 dark:text-gray-500 mt-1 px-1">
                  {isUser
                    ? language === "zh" ? "使用者" : "You"
                    : language === "zh" ? "AI代理人" : "AI Agent"}
                  {" · "}
                  {formatTime(msg.timestamp)}
                </span>
              </div>
            );
          })}
        </div>
      )}

      <div className="flex justify-end gap-2 px-3 sm:px-4 py-3 border-t border-gray-100 dark:border-gray-700">
        <button
          className="inline-flex items-center gap-1.5 px-4 py-2 bg-orange-500 text-white rounded-lg hover:bg-orange-600 transition-colors font-medium text-sm shadow-sm"
          onClick={onContinue}
        >
          {language === "zh" ? "繼續對話" : "Continue Chat"}
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 7l5 5m0 0l-5 5m5-5H6" />
          </svg>
        </button>
      </div>
    </div>
  );
}
